import React from "react";

const MapDetails = () => {
  return <div className="bg-white rounded-lg dark:bg-clrDarkBg h-44"></div>;
};

export default MapDetails;
